import EmailIcon from 'Components/Icons/EmailIcon';
import WebFormPlusIcon from 'Components/Icons/WebFormPlusIcon';
import WebForm from './DiologMenu/WebForm';
import EmailIntegration from './DiologMenu/EmailIntegration.js';

export const menuItems = [
    {
        key: 1,
        name: 'WebForm', //dynamically load the component..should match with the name of the file
        icon: () => <WebFormPlusIcon />,
        title: 'Web form',
        description: 'Enable investors to ask questions to Diolog via a web form.',
        label: 'Investor inquiry',
        path: 'web-form',
        onClick: (callback) => callback,
        type: 'WEB_FORM'
    }
    // {
    //     key: 2,
    //     name: 'EmailIntegration',
    //     icon: () => <EmailIcon />,
    //     title: 'Email integration extension',
    //     description: 'Forward emails to your question registry.',
    //     label: 'Question registry',
    //     path: 'email-extension',
    //     onClick: (callback) => callback,
    //     type: 'EMAIL_INTEGRATION'
    // }
    // {
    //     key: 2,
    //     name: 'EmailIntegration',
    //     icon: () => <EmailIcon />,
    //     title: 'Email integration extension',
    //     description: 'Forward emails to your question registry.',
    //     label: 'Question registry',
    //     path: 'email-extension',
    //     onClick: (callback) => callback
    // }
];
